import React from "react";
import {GlobalContext} from "../../GlobalContext";
import {Button, Col, Container, Form} from "react-bootstrap";

export class AdminTestSmsForm extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            to: '',
            body: '',
            success: false
        };
    }

    send = () => {
        if (!this.state.to.trim() || !this.state.body.trim()) {
            return;
        }
        this.setState({success: false}, () => {
            this.context.apiRequest("POST", "/sms/test", {
                to: this.state.to.trim(),
                body: this.state.body
            }).then(d => {
                if (d && d.status == 'OK') {
                    this.setState({success: true});
                }
            });
        });
    };

    render() {
        return <Container>
            <Form id={"sms-test-form"} onSubmit={e => e.preventDefault()}>
                <Form.Row>
                    <Form.Group as={Col} controlId="smsTo" md={6}>
                        <Form.Label size="sm">Phone number</Form.Label>
                        <Form.Control
                            name={"to"}
                            placeholder="Phone number"
                            value={this.state.to}
                            onChange={e => this.setState({to: e.target.value, success: false})}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} controlId="smsBody" md={6}>
                        <Form.Label size="sm">Message</Form.Label>
                        <Form.Control
                            as={"textarea"}
                            rows={4}
                            name={"body"}
                            placeholder="Message"
                            value={this.state.body}
                            onChange={e => this.setState({body: e.target.value, success: false})}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Col md={6}>
                        <Button variant="dark" onClick={this.send}>Send</Button>
                    </Col>
                </Form.Row>
                {
                    this.state.success ? <Form.Row>
                        <Col className={"text-center text-success mt-3"} md={6}>
                            Message sent.
                        </Col>
                    </Form.Row> : <span/>
                }
            </Form>
        </Container>
    }
}
